// extracted by mini-css-extract-plugin
module.exports = {"list":"breadcrumbs_list__3Uucd","listItem":"breadcrumbs_listItem__1yoc8"};